import type { LiveCallBooking } from '../types/liveCall';

/**
 * The thread's chip for the next lesson with this person (live lessons spec
 * section 2): before the lesson's end, "Move 5:30 PM Lesson" inside a day of
 * its start (Adjust Time), and the lesson itself. After the end nothing: the
 * call closes 15 minutes on and the lesson finishes (decisions 53, 56), and
 * "Did your lesson happen?" is asked on the lesson page only when the Dones
 * disagree (decision 59). 'happened' stays in the type for ConversationView
 * and is never returned.
 */
export type LessonChip = 'move' | 'next' | 'happened' | null;

const MINUTE = 60_000;

const endOf = (b: Pick<LiveCallBooking, 'scheduledStartAt' | 'durationMinutes'>) =>
  Date.parse(b.scheduledStartAt) + (b.durationMinutes ?? 45) * MINUTE;

export function lessonChip(b: LiveCallBooking | null, _viewerUid: string, nowMs: number): LessonChip {
  if (!b || b.status !== 'confirmed' || b.finishedAt) return null;
  const end = endOf(b);
  if (nowMs < end) return Date.parse(b.scheduledStartAt) - nowMs < 24 * 60 * MINUTE ? 'move' : 'next';
  return null;
}

/** The lesson the thread's chip is about: the earliest one still to come. */
export function chipLesson(docs: LiveCallBooking[], viewerUid: string, nowMs: number): LiveCallBooking | null {
  return docs.filter((b) => lessonChip(b, viewerUid, nowMs) !== null)
    .sort((a, b) => a.scheduledStartAt.localeCompare(b.scheduledStartAt))[0] ?? null;
}
